import React from 'react'
import { Provider } from './Context'
import { CartContainer } from './CartContainer'

export const Page = () => {
  return (
    <Provider>
      <CartContainer />
    </Provider>
  )
}
